'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faPlus } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import SubmitWithPendingButton from '@/app/_components/SubmitWithPendingButton';
import FavoritesModalImage from '@/app/_components/FavoritesModalImage';
import { withMinDuration } from '@/app/_lib/services/ClientUtil';
import addFavoritesListAction from '@/app/_lib/actions/AddFavoritesListAction';
import { useGlobalMessage } from '@/app/_lib/hooks';
const AddFavoritesListModal = t0 => {
  const $ = _c(56);
  const {
    isOpen,
    setIsOpen,
    contentLabel,
    modalData: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const modalData = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(_temp, t3);
  const addGlobalMessage = useGlobalMessage();
  const [listName, setListName] = useState("");
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const listNameInputRef = useRef(null);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setListName("");
      setErrorMessage("");
      setSuccessMessage("");
      listNameInputRef.current?.focus();
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const afterOpenModal = t4;
  let t5;
  if ($[4] !== modalData || $[5] !== setIsOpen) {
    t5 = () => {
      setIsOpen(false);
      if (modalData.onClose) {
        modalData.onClose();
      }
    };
    $[4] = modalData;
    $[5] = setIsOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const closeModal = t5;
  let t6;
  if ($[7] !== addGlobalMessage || $[8] !== listName || $[9] !== modalData) {
    t6 = async e => {
      e.preventDefault();
      setErrorMessage("");
      if (!listName || !listName.trim()) {
        setErrorMessage("Please enter a list name.");
        return;
      }
      setIsPending(true);
      const requestData = {
        list_name: listName.trim(),
        sub_product_id: modalData?.sub_product?.sub_product_id
      };
      const response = await withMinDuration(addFavoritesListAction(requestData), 700);
      if (response.success && response.favorites_lists) {
        addGlobalMessage({
          message: "Favorites list created.",
          messageType: "success"
        });
        setListName("");
        setErrorMessage("");
        setSuccessMessage("Add another list or close this window.");
        if (modalData.onClose) {
          modalData.onClose();
        }
      } else {
        setErrorMessage(response.message || Object.values(response.errors || {})[0] || "An error occurred. Please try again.");
        setSuccessMessage("");
      }
      setIsPending(false);
    };
    $[7] = addGlobalMessage;
    $[8] = listName;
    $[9] = modalData;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleSubmit = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon icon={faXmark} className="text-lg" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== closeModal) {
    t8 = <button type="button" onClick={closeModal} className="hidden md:flex absolute -top-4 -right-4 w-8 h-8 items-center justify-center bg-white rounded-full shadow-lg text-dark hover:text-primary transition-colors z-10" aria-label="Close">{t7}</button>;
    $[12] = closeModal;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FavoritesModalImage alt="Create a favorites list" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FontAwesomeIcon icon={faXmark} className="text-[28px]" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== closeModal) {
    t11 = <button onClick={closeModal} className="md:hidden absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close">{t10}</button>;
    $[16] = closeModal;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex items-center gap-3 mb-3"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-2xl text-[#F5A623]" /><h2 className="text-2xl md:text-3xl font-extralight">Create New List</h2></div>;
    t13 = <p className="text-sm text-gray-600 mb-2">Organize your favorite items into custom lists. Create a list for any occasion or project.</p>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t12 = $[18];
    t13 = $[19];
  }
  let t14;
  if ($[20] !== errorMessage) {
    t14 = errorMessage && <p className="text-sm text-red-600 mb-4">{errorMessage}</p>;
    $[20] = errorMessage;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e_0 => setListName(e_0.target.value);
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== listName) {
    t16 = <input ref={listNameInputRef} id="list_name" type="text" name="list_name" value={listName} onChange={t15} autoComplete="off" placeholder=" " required={true} className="form-input peer" />;
    $[23] = listName;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <label htmlFor="list_name" className="form-input-label peer-placeholder-shown:form-input-label-placeholder-shown">List Name</label>;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t16) {
    t18 = <div className="form-group mb-4">{t16}{t17}</div>;
    $[26] = t16;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== isPending) {
    t19 = <SubmitWithPendingButton isPending={isPending} pendingText="Creating..." icon={faPlus} size="sm">Create List</SubmitWithPendingButton>;
    $[28] = isPending;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== closeModal) {
    t20 = <button type="button" onClick={closeModal} className="text-xs text-gray-400 hover:text-gray-600 transition-colors underline">Cancel</button>;
    $[30] = closeModal;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== t19 || $[33] !== t20) {
    t21 = <div className="flex items-center gap-4">{t19}{t20}</div>;
    $[32] = t19;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== closeModal || $[36] !== successMessage) {
    t22 = successMessage && <p className="text-base text-green-600 mt-4">Great. Create more lists now or <button type="button" onClick={closeModal} className="underline hover:text-green-700">close this window</button>.</p>;
    $[35] = closeModal;
    $[36] = successMessage;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== handleSubmit || $[39] !== t14 || $[40] !== t18 || $[41] !== t21 || $[42] !== t22) {
    t23 = <form onSubmit={handleSubmit}>{t14}{t18}{t21}{t22}</form>;
    $[38] = handleSubmit;
    $[39] = t14;
    $[40] = t18;
    $[41] = t21;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t11 || $[45] !== t23) {
    t24 = <div>{t11}{t12}{t13}{t23}</div>;
    $[44] = t11;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="mt-10"><p className="text-3xs text-light leading-relaxed italic">Your favorites lists are saved to your account and can be accessed from any device when signed in.</p></div>;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t24) {
    t26 = <div className="flex flex-col md:flex-row">{t9}<div className="w-full md:w-1/2 px-6 md:px-8 py-10 md:py-14 pb-2 md:pb-3 relative flex flex-col justify-between order-1 md:order-2">{t24}{t25}</div></div>;
    $[48] = t24;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== closeModal || $[51] !== contentLabel || $[52] !== isOpen || $[53] !== t26 || $[54] !== t8) {
    t27 = <Modal overlayClassName="z-[1055] fixed outline-0 top-0 bottom-0 left-0 right-0 bg-modal-overlay" className="fixed top-1/2 left-1/2 right-auto bottom-auto -mr-[50%] -translate-y-1/2 -translate-x-1/2 w-[calc(100%-var(--site-padding)*2)] max-w-[400px] md:max-w-[800px] rounded-sm bg-white shadow-2xl outline-none overflow-visible" isOpen={isOpen} onAfterOpen={afterOpenModal} onRequestClose={closeModal} contentLabel={contentLabel} closeTimeoutMS={300} bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open">{t8}{t26}</Modal>;
    $[50] = closeModal;
    $[51] = contentLabel;
    $[52] = isOpen;
    $[53] = t26;
    $[54] = t8;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  return t27;
};
export default AddFavoritesListModal;
function _temp() {
  Modal.setAppElement("#app");
}